import { Heading, ModalBody, ModalContent, ModalHeader, VStack } from "@chakra-ui/react";
import hj from "@hotjar/browser";
import { type Account, type ChainFullId } from "@umami/chains";
import { useDynamicModalContext } from "@umami/components";
import { useGetSaplingAccount } from "@umami/state";
import { useEffect } from "react";

import { ModalBackButton } from "../BackButton";
import { ModalCloseButton } from "../CloseButton";
import { NetworkSelector } from "./NetworkSelector";
import { ReceiveModal } from "../Receive/ReceiveModal";
import { ActivateSaplingModal } from "../Sappling/ActivateSaplingModal";

type NetworkSelectorModalProps = {
  account: Account;
};

export const NetworkSelectorModal = ({ account }: NetworkSelectorModalProps) => {
  const { openWith } = useDynamicModalContext();
  const saplingAccount = useGetSaplingAccount(account.address.pkh);
  const isSaplingActive = !!saplingAccount;

  useEffect(() => {
    hj.stateChange("network_selector_modal");
  }, []);

  const handleOnClick = async (chainId: ChainFullId, isSapling?: boolean) => {
    if (isSapling && !isSaplingActive) {
      await openWith(<ActivateSaplingModal />);

      return;
    }
    await openWith(<ReceiveModal account={account} chainId={chainId} isSapling={isSapling} />);
  };

  return (
    <ModalContent>
      <ModalHeader>
        <VStack gap="12px">
          <Heading size="xl">Select Network</Heading>
        </VStack>
        <ModalBackButton />
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody>
        <VStack gap="30px">
          <NetworkSelector account={account} onClick={handleOnClick} />
        </VStack>
      </ModalBody>
    </ModalContent>
  );
};
